import axios, { AxiosResponse } from "axios";
import {AuthAttemptResource, ResetPass} from "./language-switcher.type";

/**
 * Получить последние попытки входа в систему
 */
export const authAttemptResource = (taxpayerCode: string): Promise<AxiosResponse<AuthAttemptResource[]>> => {
  return axios.get(`/services/isnaportal/open-api/auth-attempt`, {params: {
      taxpayerCode
    }});
};

/**
 * Смена пароля
 */
export const resetPassword = (data: ResetPass, token): Promise<AxiosResponse> => {
    return axios.put(`/services/isnaportal/api/user/change-credentials`, data, {
        headers: {
            'Authorization': token
        }
    });
};

export interface MyApiToken {
    requestNumber: string;
    token: string;
    issuedAt: string;
    expiredAt: string;
    blocked: boolean;
}

export const getMyApiToken = (
    accessToken?: string
): Promise<AxiosResponse<MyApiToken>> => {
    return axios.get('/services/isnaportal/api/token/my-token', {
        headers: accessToken
            ? {
                  Authorization: `Bearer ${accessToken}`,
              }
            : undefined,
    });
};